export const getDebugInfo = (debugInfo: { timestamp: string; callId: string }[]) => {
    const result = debugInfo.map(info => {
        return `[${info.timestamp}]: ${info.callId}`;
    });

    return result.join('\n\n');
};
